<div *ngIf="buckets.length"
     class="my-inwards-pill hidden md:inline-flex"
     [matTooltip]="'My pending inwards (' + totalCount + ' total) — click to open list'">

    <button type="button"
            class="my-inwards-nav"
            (click)="prev(); $event.stopPropagation()"
            matTooltip="Previous status"
            aria-label="Previous status">
        <mat-icon [svgIcon]="'heroicons_solid:chevron-up'"></mat-icon>
    </button>

    <div class="my-inwards-content" (click)="openStatus()">
        <span class="my-inwards-label">My Workload</span>
        <span class="my-inwards-name">
            {{ current?.label }}
            <span class="my-inwards-count">{{ current?.count }}</span>
        </span>
    </div>

    <button type="button"
            class="my-inwards-nav"
            (click)="next(); $event.stopPropagation()"
            matTooltip="Next status"
            aria-label="Next status">
        <mat-icon [svgIcon]="'heroicons_solid:chevron-down'"></mat-icon>
    </button>

    <button type="button"
            class="my-inwards-pause"
            (click)="togglePause(); $event.stopPropagation()"
            [matTooltip]="paused ? 'Resume auto-rotate' : 'Pause auto-rotate'"
            [attr.aria-label]="paused ? 'Resume auto-rotate' : 'Pause auto-rotate'">
        <mat-icon [svgIcon]="paused ? 'heroicons_solid:play' : 'heroicons_solid:pause'"></mat-icon>
    </button>
</div>
